import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.83333 2.5H5.16667C4.45942 2.5 3.78115 2.78095 3.28105 3.28105C2.78095 3.78115 2.5 4.45942 2.5 5.16667V10.8333C2.5 11.5406 2.78095 12.2189 3.28105 12.719C3.78115 13.219 4.45942 13.5 5.16667 13.5H10.8333C11.5406 13.5 12.2189 13.219 12.719 12.719C13.219 12.2189 13.5 11.5406 13.5 10.8333V9.16667M9.16667 2.5H12.8333C13.0173 2.5 13.184 2.57467 13.3047 2.69533M13.3047 2.69533C13.4297 2.82033 13.5 2.98987 13.5 3.16667V6.83333M13.3047 2.69533L12.8333 3.16667L8.5 7.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgExternalLink;
